import {DateFormatter} from "../date";

/**
 * Given an offer check if it is expired or not
 *
 * @param offer
 * @returns {boolean}
 */
export const offerIsExpired = (offer) => {
    const today = Date.now();
    const todayISOString = DateFormatter.onlyDateISOString(today);

    return todayISOString > offer["endDate"];
};

/**
 * Comparator used to sort the offer.
 * It sort on offer by: startDate ASC, endDate ASC
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const offerComparator = (a, b) => {
    if (a.startDate > b.startDate) {
        return 1;
    }
    if (b.startDate > a.startDate) {
        return -1;
    }
    if (a.endDate > b.endDate) {
        return 1;
    }
    if (b.endDate > a.endDate) {
        return -1;
    }
    return 0;
};